var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.792 13.377v5.746L7.292 19v-5.623s0-4.167 6.25-4.167 6.25 4.167 6.25 4.167zm-3.125-9.375a3.125 3.125 0 00-5.335-2.21 3.125 3.125 0 00.473 4.808 3.125 3.125 0 004.862-2.598zM20 9.272a5.833 5.833 0 011.875 4.105V19H25v-5.623s0-3.594-5-4.104zM18.75.878a3.031 3.031 0 00-.927.146 5.208 5.208 0 010 5.958c.3.097.612.146.927.146a3.125 3.125 0 100-6.25zM8.333 6.085H5.208V2.96H3.125v3.125H0V8.17h3.125v3.125h2.083V8.169h3.125V6.085z"
  })));
}

export default SvgInvite;